module.exports = __webpack_public_path__ + "static/about-illu-2-2ffb42c5a0be5beddad890685df61dcf.png";